import React from "react";
import { PageHeader } from "./PageHeader"
import { DataBox } from "./DataBox"
import { useChargebackModel } from "../chargebackModel";
import { Print } from "./Print"
import { ScaniaPrints } from "./scaniaPrint"
import { SettleScaniaPrints } from "./settleScaniaPrints"
import { PrintMaintenanceSettle } from "../../view/PrintMaintenanceSettle"

export default () => {
    const {
        print,
        scaniaPrint: { visible },
        settleScaniaPrint,
        printSettleVisible, setPrintSettleVisible,
        printParam, descRows
    } = useChargebackModel();
    return (
        <>
            <PageHeader />
            <DataBox />
            {print && <Print />}
            {visible && <ScaniaPrints />}
            {settleScaniaPrint && <SettleScaniaPrints />}
            {printSettleVisible && <PrintMaintenanceSettle printSettleVisible={printSettleVisible} setPrintSettleVisible={setPrintSettleVisible} printParam={printParam} selectRows={descRows} />}
        </>
    )
}